var _circle, _circle2, _g, _path, _path2, _g2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalloweenOtto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 55.5,
    r: 55.5,
    fill: "url(#paint0_radial_421:19)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_421:19",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 111,
    height: 111
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 55.5,
    r: 55.5,
    fill: "#FFFBEB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_421:19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8304 37.2565C69.7383 42.2091 73.4569 41.7817 79.0621 49.7047C84.9936 58.089 87.5833 56.757 90.2925 59.2868C93.0017 61.8166 95.4046 46.4243 84.5357 37.606C77.5583 31.945 67.9226 32.3039 68.8304 37.2565Z",
    fill: "#AEA075"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3233 30.7142C72.123 35.9916 79.0295 38.3147 84.6347 46.2377C90.5662 54.622 87.4935 61.8431 90.2028 64.3729C92.912 66.9027 98.8622 43.5639 89.2133 33.4251C78.0279 21.6718 74.5235 25.4368 73.3233 30.7142Z",
    fill: "#D1C394"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7002 38.2565C42.7924 43.2091 39.0738 42.7817 33.4686 50.7047C27.537 59.089 24.9474 57.757 22.2382 60.2868C19.5289 62.8166 17.126 47.4243 27.995 38.606C34.9723 32.945 44.608 33.3039 43.7002 38.2565Z",
    fill: "#AEA075"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2074 31.7142C40.4076 36.9916 33.5012 39.3147 27.896 47.2377C21.9644 55.622 25.0371 62.8431 22.3279 65.3729C19.6186 67.9027 13.6684 44.5639 23.3173 34.4251C34.5027 22.6718 38.0071 26.4368 39.2074 31.7142Z",
    fill: "#D1C294"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 115C90 115 77 127 55.5 127C35.5 127 23.5 116.5 23.5 116.5C23.5 99.3792 33 49.5 55.5 49.5C75.5 49.5 90 97.8792 90 115Z",
    fill: "url(#paint1_linear_421:19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3482 28.0047C15.0688 28.5707 38.2225 79.2538 40.6943 83.7109C43.1662 88.1681 70.166 88.1679 72.6636 83.2651C75.1612 78.3623 97.6276 27.4387 56.3482 28.0047Z",
    fill: "url(#paint2_linear_421:19)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.4443 55.4492C49.577 57.3816 47.5916 55.5764 45.3062 55.7333C43.0208 55.8902 41.3008 57.9498 41.1681 56.0174C41.0355 54.085 42.8527 53.4409 45.1381 53.284C47.4235 53.1272 49.3117 53.5168 49.4443 55.4492Z",
    fill: "#3D3D3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.059 55.4492C63.9263 57.3816 65.9116 55.5764 68.1971 55.7333C70.4825 55.8902 72.2025 57.9498 72.3352 56.0174C72.4678 54.085 70.6506 53.4409 68.3652 53.284C66.0798 53.1272 64.1916 53.5168 64.059 55.4492Z",
    fill: "#3D3D3D"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_421:19)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2793 88.6034C68.3005 88.823 104.942 89.5532 98.9053 52.8758C92.8877 16.312 74.8072 20.5831 62.6821 23.4474C59.9028 24.1039 57.4365 24.6866 55.5 24.6866C54.394 24.6866 53.0918 24.6372 51.6443 24.5824C39.5006 24.1223 17.1254 23.2745 14.4927 47.9194C9.8574 91.313 40.913 89.4215 52.6062 88.7093C53.7872 88.6373 54.7707 88.5774 55.5 88.5774C55.9767 88.5774 56.5754 88.5894 57.2784 88.6034L57.2793 88.6034ZM56.7516 84.5512C65.3256 84.5512 72.2762 79.3034 72.2762 72.8299C72.2762 66.3565 65.3256 61.1087 56.7516 61.1087C48.1777 61.1087 41.2271 66.3565 41.2271 72.8299C41.2271 79.3034 48.1777 84.5512 56.7516 84.5512ZM52.8806 54.2185C52.8806 58.4286 49.3073 61.8415 44.8994 61.8415C40.4915 61.8415 36.9183 58.4286 36.9183 54.2185C36.9183 50.0085 40.4915 46.5955 44.8994 46.5955C49.3073 46.5955 52.8806 50.0085 52.8806 54.2185ZM67.9728 61.8415C72.3807 61.8415 75.954 58.4286 75.954 54.2185C75.954 50.0085 72.3807 46.5955 67.9728 46.5955C63.565 46.5955 59.9917 50.0085 59.9917 54.2185C59.9917 58.4286 63.565 61.8415 67.9728 61.8415Z",
    fill: "#DA7601"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7221 6.64463C58.04 5.69719 59.3978 5.75073 59.6402 6.72026L60.9125 11.8092C60.948 11.951 60.9509 12.1034 60.9236 12.2471C59.4311 20.0834 60.8224 21.4592 60.9562 26.7946C60.9681 27.2688 60.6339 27.6804 60.1669 27.7637C59.1365 27.9473 57.3157 28.2327 55.9538 28.2327C54.6958 28.2327 52.9457 27.9892 51.814 27.8073C51.2156 27.7111 50.8568 27.1006 51.0496 26.526L57.7221 6.64463Z",
    fill: "#72662B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3846 76.3819C56.3846 76.3819 63.5515 71.529 63.599 80.1322C63.6333 86.3309 60.3992 90.6876 56.3756 90.7098C52.352 90.7321 49.0626 86.4114 49.0284 80.2127C48.9832 72.035 56.3846 76.3819 56.3846 76.3819Z",
    fill: "#C18282"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.422 76.5C56.422 76.5 43.1924 86.5407 43.1059 75.1525C43.0436 66.9471 49.0055 61.1583 56.422 61.102C63.8384 61.0457 69.901 66.7432 69.9633 74.9486C70.0455 85.7736 56.422 76.5 56.422 76.5Z",
    fill: "#AFA16E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9773 66.7024C61.9988 68.8345 59.4988 71.9695 56.475 72C53.4512 72.0305 51.0488 68.945 51.0273 66.8129C51.0058 64.6807 53.4512 64.0857 56.475 64.0552C59.4988 64.0247 61.9558 64.5703 61.9773 66.7024Z",
    fill: "#3D3D3D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5422 30.225C29.5422 30.225 24.6943 34.3456 22.9975 52.5251C21.3007 70.7045 28.0878 82.0971 28.0878 82.0971",
    stroke: "#B5670D",
    strokeOpacity: 0.44
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7742 28.7467C83.7742 28.7467 88.622 32.8674 90.3188 51.0468C92.0156 69.2262 85.2286 80.6188 85.2286 80.6188",
    stroke: "#B5670D",
    strokeOpacity: 0.44
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4087 27.6238C71.4087 27.6238 75.6479 32.3683 78.1351 52.1192C80.6224 71.8702 75.7163 83.777 75.7163 83.777",
    stroke: "#B5670D",
    strokeOpacity: 0.44
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1676 29.7417C42.1676 29.7417 37.9284 34.4862 35.4412 54.2372C32.954 73.9881 37.86 85.895 37.86 85.895",
    stroke: "#B5670D",
    strokeOpacity: 0.44
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_421:19",
    x: 9.0249,
    y: 16.6296,
    width: 95.5472,
    height: 77.323,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_421:19"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_421:19",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_421:19",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.5 55.5) rotate(90) scale(55.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#6A6A5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_421:19",
    x1: 56.75,
    y1: 50,
    x2: 56.75,
    y2: 127.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#897E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0D2A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_421:19",
    x1: 56.5,
    y1: 28,
    x2: 56.5,
    y2: 87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1C394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC9F6E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalloweenOtto);
export default __webpack_public_path__ + "static/media/halloween-otto.452aaa24e0d10d9cc90969daf1f240e3.svg";
export { ForwardRef as ReactComponent };